import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://www.northinteractive.co';
const SITE_NAME = 'North';
const DEFAULT_DESCRIPTION = 'Fractional CTO services, AI strategy consulting, cloud architecture, and data analytics for startups and mid-market companies.';

const SEOHead = ({
  title,
  description = DEFAULT_DESCRIPTION,
  path = '',
  type = 'website',
  article = null,
  noindex = false,
}) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Fractional CTO & Technology Consulting`;
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />

      {/* Article-specific meta */}
      {article && (
        <>
          <meta property="article:published_time" content={article.date} />
          <meta property="article:author" content="North" />
          <meta property="article:section" content={article.category} />
        </>
      )}

      {/* Article JSON-LD */}
      {article && (
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: article.title,
            description: article.excerpt,
            datePublished: article.date,
            dateModified: article.date,
            author: {
              '@type': 'Person',
              name: 'North',
              url: 'https://www.northinteractive.co',
            },
            publisher: {
              '@type': 'Organization',
              name: 'North',
              url: SITE_URL,
            },
            mainEntityOfPage: {
              '@type': 'WebPage',
              '@id': url,
            },
            articleSection: article.category,
            url: url,
          })}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;
